export default __webpack_public_path__ + "static/media/mb-cta-book.6f15432c.svg";